module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-vodafonecvm-00.1.99251bfa.jpg";